import { t } from '@/i18n'
import type { ZReport } from '@/types'

import type { TicketElement } from './components'
import {
  EmptySeparator,
  InfoItem,
  Label,
  Section,
  Separator,
  TaxesBreakdown,
  Total
} from './components'

function payments(report: ZReport) {
  const sortedPayments = Object.keys(report.payments)
    .map(method => ({
      method,
      amount: report.payments[method]
    }))
    .sort((a, b) => b.amount - a.amount)
  let paymentsArray: TicketElement[] = []
  for (let i = 0; i < sortedPayments.length; ++i) {
    paymentsArray = [
      ...paymentsArray,
      new InfoItem(
        sortedPayments[i].method.charAt(0).toUpperCase() + sortedPayments[i].method.slice(1),
        sortedPayments[i].amount,
        {
          valueType: 'currency'
        }
      )
    ]
  }
  const totalTips = Object.values(report.tips).reduce((total, amount) => (total += amount), 0)
  const result = [
    new Section(t('report.billing')),
    ...paymentsArray,
    new EmptySeparator(),
    new InfoItem('*' + t('report.tips'), totalTips, {
      valueType: 'currency'
    })
  ]
  return result
}

function breakdown(reportBreakdown: ZReport['breakdown']) {
  const taxRates =
    Object.keys(reportBreakdown.taxRates).length > 0
      ? Object.values(reportBreakdown.taxRates)
      : [
          {
            taxPercentage: reportBreakdown.taxPercentage!,
            taxableBase: reportBreakdown.taxableBase,
            tax: reportBreakdown.tax,
            total: reportBreakdown.total
          }
        ]
  return [new TaxesBreakdown(taxRates, reportBreakdown.taxLabel!), new Total(reportBreakdown.total)]
}

function generateRealTimeReport(
  report: ZReport,
  config: { company: { name: string; taxId: string; address: string } }
) {
  return [
    new Label(t('report.real-time-report'), {
      style: 'bold 24px',
      lineHeight: 30
    }),
    new InfoItem(t('report.date'), report.startDate, {
      valueType: 'dateWithoutTime',
      style: '16px'
    }),
    new EmptySeparator(),
    new Label(config.company.name, { style: 'bold 24px', lineHeight: 30 }),
    new Label(config.company.taxId, { style: '16px', lineHeight: 30 }),
    new Label(config.company.address, { style: '16px', lineHeight: 30 }),
    new Section(t('report.general')),
    new InfoItem(t('report.total-tabs'), report.stats.totalTabs),
    new InfoItem(t('report.discounts'), -report.breakdown.discounts, {
      valueType: 'currency'
    }),
    new Section(t('report.till-control')),
    new InfoItem(t('report.pay-in'), report.totalIns, {
      valueType: 'currency'
    }),
    new InfoItem(t('report.pay-out'), -report.totalOuts, {
      valueType: 'currency'
    }),
    ...payments(report),
    new Separator(),
    new InfoItem(t('report.taxable-base'), report.breakdown.taxableBase, {
      valueType: 'currency',
      light: true
    }),
    new EmptySeparator(),
    ...breakdown(report.breakdown)
  ]
}

export default generateRealTimeReport
